import ApiClient from '../ApiClient';

class LumerAIBulkActionsAPI extends ApiClient {
  constructor() {
    super('lumerai/bulk_actions', { accountScoped: true });
  }
}

export default new LumerAIBulkActionsAPI();
